import { useMemo } from 'react'
import { TripPayload } from '../../../../../../store/trips/trips.types'
import { isOrderLinkedHookTrailerTask } from '../../../trip-selection-old/trip-orders-list/trip-order-event.utils'

export const useTripDetailsAction = (
  tripTasks: TripPayload[],
  index: number
) => {
  const { type } = tripTasks[index]

  const showCloseIcon = useMemo(() => {
    const hasTrailer = tripTasks.some(
      (task) => task.type === 'HOOK_TRAILER' || task.type === 'DROP_TRAILER'
    )
    const isTractorOnly = tripTasks.every(
      (task) => task.type === 'HOOK_TRACTOR' || task.type === 'DROP_TRACTOR'
    )

    // Tractor hook: removable when no trailer is on the trip
    if (type === 'HOOK_TRACTOR') {
      return !hasTrailer
    }

    // Tractor drop: removable only when the trip is hook + drop tractor alone
    if (type === 'DROP_TRACTOR') {
      return !hasTrailer && isTractorOnly
    }

    // Equipment trailer pair hook row
    if (
      type === 'HOOK_TRAILER' &&
      tripTasks[index + 1]?.type === 'DROP_TRAILER'
    ) {
      return true
    }

    if (isOrderLinkedHookTrailerTask(tripTasks[index])) {
      const orderId = tripTasks[index].orderId
      if (!orderId) return true

      const hasDeliveryForOrder = tripTasks.some(
        (task) => task.orderId === orderId && task.type === 'DELIVERY'
      )
      return !hasDeliveryForOrder
    }

    if (type === 'DROP_TRAILER') return true

    if (type === 'DELIVERY') return true

    if (type === 'PICKUP') {
      const orderId = tripTasks[index].orderId
      if (!orderId) return true

      const hasDeliveryForOrder = tripTasks.some(
        (task) => task.orderId === orderId && task.type === 'DELIVERY'
      )
      return !hasDeliveryForOrder
    }

    return false
  }, [index, tripTasks, type])

  return { showCloseIcon }
}
